import {useQuery} from "@tanstack/react-query";
import {qk} from "@queries/keys";
import {EventFilters} from "@lib/Event/EventModels";
import EventService from "@lib/Event/EventService";
import {cleanObject} from "@commons/misc/cleanObject";
import {useMemo} from "react";
import {PaginationParameters} from "@api/ApiModels";

export function useEvents(filters?: EventFilters) {

    const cleanFilters = useMemo(
        () => cleanObject(filters, {removeEmptyString: true}),
        [filters]
    ) as Required<EventFilters>;

    return useQuery({
        queryKey: qk.events(cleanFilters),
        queryFn: () => EventService.getEventList(cleanFilters),
        staleTime: 10 * 60_000,
        retry: 1,
    });
}

export function useEvent(eventId?: string) {
    return useQuery({
        queryKey: qk.event(eventId),
        queryFn: () => {
            if (!eventId) throw new Error('Missing eventId');
            return EventService.getEventDetails(eventId)
        },
        staleTime: 10 * 60_000,
        retry: 1,
        enabled: !!eventId,
    });
}

export function useInvoices(filters?: PaginationParameters) {

    const cleanFilters = useMemo(
        () => cleanObject({page: 0, size: 250, ...filters}, {removeEmptyString: true}),
        [filters]
    ) as Required<EventFilters>;

    return useQuery({
        queryKey: qk.invoices(cleanFilters),
        queryFn: () => EventService.getInvoices(cleanFilters),
        staleTime: 10 * 60_000,
        retry: 1,
        select: (data) => {
            return [...data].sort(
                (a, b) =>
                    new Date(b.createdDate).getTime() -
                    new Date(a.createdDate).getTime()
            );
        },
    });
}